import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "dots-4-vertical-divider-32", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 2 32", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { stroke: "#000", strokeWidth: 1.5, d: "M1 10.75V22.5", fill: "none", strokeDasharray: "0,3.5", strokeLinecap: "round", strokeOpacity: 0.1 }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
